/*
 * @description: 系统路由配置
 * @author: xuy
 * @since: 2020-03-31 11:03:46
 * @version: 1.0
 */
import PublicLayout from '@/framework/layout2/PublicLayout.vue'
export default [
  {
    path: '/register/index',
      component: () => import('@/app/register/views/index'),
      name: 'Register',
      meta: { title: 'module.register.098677-0', icon: '', noCache: true, breadcrumb:true ,whiteList:true }
  },
  {
    path: '/register/base-info',
      component: () => import('@/app/register/views/base-info'),
      name: 'RegisterBaseInfo',
      meta: { title: 'module.register.098677-1', icon: '', noCache: true, breadcrumb:true ,whiteList:true }
  },
  {
    path: '/register/contact-supply-range',
      component: () => import('@/app/register/views/contact-supply-range'),
      name: 'RegisterContactServiceRange',
      meta: { title: 'module.register.098677-2', icon: '', noCache: true, breadcrumb:true ,whiteList:true }
  },
  {
    path: '/register/financial-info',
      component: () => import('@/app/register/views/financial-info'),
      name: 'RegisterFinancialInfo',
      meta: { title: 'module.register.098677-3', icon: '', noCache: true, breadcrumb:true ,whiteList:true }
  },
  {
    path: '/forgetPwd',
      component: () => import('@/app/register/views/forget-password'),
      name: 'ForgetPassword',
      meta: { title: 'module.register.098677-4', icon: '', noCache: true, breadcrumb:true ,whiteList:true }
  },
  {
    path: '/reconciliation-statement',
    component: () => import('@/app/home/views/serviceCenter/reconciliationStatement'),
    name: 'reconciliationStatement',
    meta: { title: 'layout2.PublicLayoutHeader.259589-2', icon: '', noCache: true, breadcrumb:true ,whiteList:true }
  },
]
